
import { FSharpRef, Union } from "./fable_modules/fable-library-js.5.0.0/Types.js";
import { option_type, class_type, union_type } from "./fable_modules/fable-library-js.5.0.0/Reflection.js";
import { WeatherTypeModule_ParameterModule_name, WeatherTypeModule_ParameterModule_parse, WeatherTypeModule_Parameter, WeatherTypeModule_Parameter_$reflection } from "./StenaWeather.Domain/Weather.js";
import { VoyageId, VoyageId_$reflection } from "./StenaWeather.Domain/Sessions.js";
import { DateTimeRange, SensorId, DateTimeRange_$reflection, SensorId_$reflection } from "./StenaWeather.Domain/PortWind.js";
import { tryParse, minValue } from "./fable_modules/fable-library-js.5.0.0/DateOffset.js";
import { append, choose, ofArray, singleton, empty, tail, head, isEmpty } from "./fable_modules/fable-library-js.5.0.0/List.js";
import { Route_$007CGuid$007C_$007C, Route_$007CQuery$007C_$007C } from "./lib/Feliz.Router/Router.js";
import { defaultArgWith, defaultArg, map, toArray } from "./fable_modules/fable-library-js.5.0.0/Option.js";
import { toString } from "./fable_modules/fable-library-js.5.0.0/Date.js";
import { concat } from "./fable_modules/fable-library-js.5.0.0/String.js";
import { RouterModule_encodeParts, RouterModule_trySeparateLast, RouterModule_encodeQueryString, RouterModule_nav } from "./lib/Feliz.Router/Router.js";
import { Cmd_ofEffect } from "./fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";

export class PortWindSubpage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Table", "Dashboard"];
    }
}

export function PortWindSubpage_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.Router.PortWindSubpage", [], PortWindSubpage, () => [[], []]);
}

export function PortWindSubpage_get_Default() {
    return new PortWindSubpage(0, []);
}

export class Page extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Models", "Vessels", "SessionDetails", "SessionReport", "Dashboard", "PortWind", "PortWindSimple", "PortWindReport", "PortWindStatus", "PortWindOutageReport", "Logout", "Login", "LoginCallback", "LoginCallbackSilent"];
    }
}

export function Page_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.Router.Page", [], Page, () => [[["Item", WeatherTypeModule_Parameter_$reflection()]], [], [["Item", VoyageId_$reflection()]], [["Item", class_type("System.Guid")]], [], [["Item", option_type(SensorId_$reflection())]], [["Item", option_type(SensorId_$reflection())]], [["Item1", option_type(SensorId_$reflection())], ["Item2", DateTimeRange_$reflection()]], [], [["Item", option_type(SensorId_$reflection())]], [], [], [], []]);
}

export const PageModule_dateFormat = "o";

export function PageModule_dateParse(s) {
    let matchValue;
    let outArg = minValue();
    matchValue = [tryParse(s, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    if (matchValue[0]) {
        return matchValue[1];
    }
    else {
        return undefined;
    }
}

export const PageModule_defaultPage = new Page(0, [new WeatherTypeModule_Parameter(0, [])]);

export function PageModule_isLoginPage(_arg) {
    switch (_arg.tag) {
        case 11:
        case 10:
        case 12:
        case 13:
            return true;
        default:
            return false;
    }
}

export function PageModule_menuVisible(_arg) {
    if (_arg.tag === 6) {
        return false;
    }
    else {
        return true;
    }
}

export function PageModule_themeSwitcherVisible(_arg) {
    if (_arg.tag === 6) {
        return false;
    }
    else {
        return true;
    }
}

export function PageModule_parseFromUrlSegments(_arg) {
    let matchResult, p;
    if (!isEmpty(_arg)) {
        switch (head(_arg)) {
            case "logout": {
                if (isEmpty(tail(_arg))) {
                    matchResult = 0;
                }
                else {
                    matchResult = 5;
                }
                break;
            }
            case "login": {
                if (isEmpty(tail(_arg))) {
                    matchResult = 1;
                }
                else {
                    matchResult = 5;
                }
                break;
            }
            case "login-callback": {
                if (!isEmpty(tail(_arg))) {
                    if (isEmpty(tail(tail(_arg)))) {
                        matchResult = 2;
                    }
                    else {
                        matchResult = 5;
                    }
                }
                else {
                    matchResult = 5;
                }
                break;
            }
            case "login-callback-silent": {
                if (!isEmpty(tail(_arg))) {
                    if (isEmpty(tail(tail(_arg)))) {
                        matchResult = 3;
                    }
                    else {
                        matchResult = 5;
                    }
                }
                else {
                    matchResult = 5;
                }
                break;
            }
            case "models": {
                if (!isEmpty(tail(_arg))) {
                    const activePatternResult = Route_$007CQuery$007C_$007C(head(tail(_arg)));
                    if (activePatternResult != null) {
                        if (!isEmpty(activePatternResult)) {
                            if (head(activePatternResult)[0] === "param") {
                                if (isEmpty(tail(activePatternResult))) {
                                    if (isEmpty(tail(tail(_arg)))) {
                                        matchResult = 4;
                                        p = head(activePatternResult)[1];
                                    }
                                    else {
                                        matchResult = 5;
                                    }
                                }
                                else {
                                    matchResult = 5;
                                }
                            }
                            else {
                                matchResult = 5;
                            }
                        }
                        else {
                            matchResult = 5;
                        }
                    }
                    else {
                        matchResult = 5;
                    }
                }
                else {
                    matchResult = 5;
                }
                break;
            }
            default:
                matchResult = 5;
        }
    }
    else {
        matchResult = 5;
    }
    switch (matchResult) {
        case 0:
            return new Page(10, []);
        case 1:
            return new Page(11, []);
        case 2:
            return new Page(12, []);
        case 3:
            return new Page(13, []);
        case 4:
            return new Page(0, [WeatherTypeModule_ParameterModule_parse(p)]);
        default: {
            let matchResult_1, i;
            if (!isEmpty(_arg)) {
                if (head(_arg) === "sessions") {
                    if (!isEmpty(tail(_arg))) {
                        const activePatternResult_1 = Route_$007CGuid$007C_$007C(head(tail(_arg)));
                        if (activePatternResult_1 != null) {
                            if (isEmpty(tail(tail(_arg)))) {
                                matchResult_1 = 0;
                                i = activePatternResult_1;
                            }
                            else {
                                matchResult_1 = 1;
                            }
                        }
                        else {
                            matchResult_1 = 1;
                        }
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0:
                    return new Page(2, [new VoyageId(0, [i])]);
                default: {
                    let matchResult_2, i_1, lastSessionId;
                    if (!isEmpty(_arg)) {
                        if (head(_arg) === "sessions") {
                            if (!isEmpty(tail(_arg))) {
                                const activePatternResult_2 = Route_$007CGuid$007C_$007C(head(tail(_arg)));
                                if (activePatternResult_2 != null) {
                                    if (!isEmpty(tail(tail(_arg)))) {
                                        if (head(tail(tail(_arg))) === "merged") {
                                            if (!isEmpty(tail(tail(tail(_arg))))) {
                                                const activePatternResult_3 = Route_$007CGuid$007C_$007C(head(tail(tail(tail(_arg)))));
                                                if (activePatternResult_3 != null) {
                                                    if (isEmpty(tail(tail(tail(tail(_arg)))))) {
                                                        matchResult_2 = 0;
                                                        i_1 = activePatternResult_2;
                                                        lastSessionId = activePatternResult_3;
                                                    }
                                                    else {
                                                        matchResult_2 = 1;
                                                    }
                                                }
                                                else {
                                                    matchResult_2 = 1;
                                                }
                                            }
                                            else {
                                                matchResult_2 = 1;
                                            }
                                        }
                                        else {
                                            matchResult_2 = 1;
                                        }
                                    }
                                    else {
                                        matchResult_2 = 1;
                                    }
                                }
                                else {
                                    matchResult_2 = 1;
                                }
                            }
                            else {
                                matchResult_2 = 1;
                            }
                        }
                        else {
                            matchResult_2 = 1;
                        }
                    }
                    else {
                        matchResult_2 = 1;
                    }
                    switch (matchResult_2) {
                        case 0:
                            return new Page(2, [new VoyageId(1, [i_1, lastSessionId])]);
                        default: {
                            let matchResult_3, i_2;
                            if (!isEmpty(_arg)) {
                                if (head(_arg) === "sessions") {
                                    if (!isEmpty(tail(_arg))) {
                                        const activePatternResult_4 = Route_$007CGuid$007C_$007C(head(tail(_arg)));
                                        if (activePatternResult_4 != null) {
                                            if (!isEmpty(tail(tail(_arg)))) {
                                                if (head(tail(tail(_arg))) === "report") {
                                                    if (isEmpty(tail(tail(tail(_arg))))) {
                                                        matchResult_3 = 0;
                                                        i_2 = activePatternResult_4;
                                                    }
                                                    else {
                                                        matchResult_3 = 1;
                                                    }
                                                }
                                                else {
                                                    matchResult_3 = 1;
                                                }
                                            }
                                            else {
                                                matchResult_3 = 1;
                                            }
                                        }
                                        else {
                                            matchResult_3 = 1;
                                        }
                                    }
                                    else {
                                        matchResult_3 = 1;
                                    }
                                }
                                else {
                                    matchResult_3 = 1;
                                }
                            }
                            else {
                                matchResult_3 = 1;
                            }
                            switch (matchResult_3) {
                                case 0:
                                    return new Page(3, [i_2]);
                                default: {
                                    let matchResult_4, sensorId;
                                    if (!isEmpty(_arg)) {
                                        switch (head(_arg)) {
                                            case "vessels": {
                                                if (isEmpty(tail(_arg))) {
                                                    matchResult_4 = 0;
                                                }
                                                else {
                                                    matchResult_4 = 4;
                                                }
                                                break;
                                            }
                                            case "dashboard": {
                                                if (isEmpty(tail(_arg))) {
                                                    matchResult_4 = 1;
                                                }
                                                else {
                                                    matchResult_4 = 4;
                                                }
                                                break;
                                            }
                                            case "portwind-status": {
                                                if (isEmpty(tail(_arg))) {
                                                    matchResult_4 = 2;
                                                }
                                                else {
                                                    matchResult_4 = 4;
                                                }
                                                break;
                                            }
                                            case "portwind-outage-report": {
                                                if (!isEmpty(tail(_arg))) {
                                                    const activePatternResult_5 = Route_$007CQuery$007C_$007C(head(tail(_arg)));
                                                    if (activePatternResult_5 != null) {
                                                        if (!isEmpty(activePatternResult_5)) {
                                                            if (head(activePatternResult_5)[0] === "sensor") {
                                                                if (isEmpty(tail(activePatternResult_5))) {
                                                                    if (isEmpty(tail(tail(_arg)))) {
                                                                        matchResult_4 = 3;
                                                                        sensorId = head(activePatternResult_5)[1];
                                                                    }
                                                                    else {
                                                                        matchResult_4 = 4;
                                                                    }
                                                                }
                                                                else {
                                                                    matchResult_4 = 4;
                                                                }
                                                            }
                                                            else {
                                                                matchResult_4 = 4;
                                                            }
                                                        }
                                                        else {
                                                            matchResult_4 = 4;
                                                        }
                                                    }
                                                    else {
                                                        matchResult_4 = 4;
                                                    }
                                                }
                                                else {
                                                    matchResult_4 = 4;
                                                }
                                                break;
                                            }
                                            default:
                                                matchResult_4 = 4;
                                        }
                                    }
                                    else {
                                        matchResult_4 = 4;
                                    }
                                    switch (matchResult_4) {
                                        case 0:
                                            return new Page(1, []);
                                        case 1:
                                            return new Page(4, []);
                                        case 2:
                                            return new Page(8, []);
                                        case 3:
                                            return new Page(9, [new SensorId(sensorId)]);
                                        default: {
                                            let matchResult_5, sensorId_1;
                                            if (!isEmpty(_arg)) {
                                                switch (head(_arg)) {
                                                    case "portwind-outage-report": {
                                                        if (isEmpty(tail(_arg))) {
                                                            matchResult_5 = 0;
                                                        }
                                                        else {
                                                            matchResult_5 = 2;
                                                        }
                                                        break;
                                                    }
                                                    case "portwind": {
                                                        if (!isEmpty(tail(_arg))) {
                                                            const activePatternResult_6 = Route_$007CQuery$007C_$007C(head(tail(_arg)));
                                                            if (activePatternResult_6 != null) {
                                                                if (!isEmpty(activePatternResult_6)) {
                                                                    if (head(activePatternResult_6)[0] === "sensor") {
                                                                        if (isEmpty(tail(activePatternResult_6))) {
                                                                            if (isEmpty(tail(tail(_arg)))) {
                                                                                matchResult_5 = 1;
                                                                                sensorId_1 = head(activePatternResult_6)[1];
                                                                            }
                                                                            else {
                                                                                matchResult_5 = 2;
                                                                            }
                                                                        }
                                                                        else {
                                                                            matchResult_5 = 2;
                                                                        }
                                                                    }
                                                                    else {
                                                                        matchResult_5 = 2;
                                                                    }
                                                                }
                                                                else {
                                                                    matchResult_5 = 2;
                                                                }
                                                            }
                                                            else {
                                                                matchResult_5 = 2;
                                                            }
                                                        }
                                                        else {
                                                            matchResult_5 = 2;
                                                        }
                                                        break;
                                                    }
                                                    default:
                                                        matchResult_5 = 2;
                                                }
                                            }
                                            else {
                                                matchResult_5 = 2;
                                            }
                                            switch (matchResult_5) {
                                                case 0:
                                                    return new Page(9, [undefined]);
                                                case 1:
                                                    return new Page(5, [new SensorId(sensorId_1)]);
                                                default: {
                                                    let matchResult_6, sensorId_2;
                                                    if (!isEmpty(_arg)) {
                                                        switch (head(_arg)) {
                                                            case "portwind": {
                                                                if (isEmpty(tail(_arg))) {
                                                                    matchResult_6 = 0;
                                                                }
                                                                else if (isEmpty(tail(tail(_arg)))) {
                                                                    matchResult_6 = 0;
                                                                }
                                                                else {
                                                                    matchResult_6 = 2;
                                                                }
                                                                break;
                                                            }
                                                            case "portwind-simple": {
                                                                if (!isEmpty(tail(_arg))) {
                                                                    const activePatternResult_7 = Route_$007CQuery$007C_$007C(head(tail(_arg)));
                                                                    if (activePatternResult_7 != null) {
                                                                        if (!isEmpty(activePatternResult_7)) {
                                                                            if (head(activePatternResult_7)[0] === "sensor") {
                                                                                if (isEmpty(tail(activePatternResult_7))) {
                                                                                    if (isEmpty(tail(tail(_arg)))) {
                                                                                        matchResult_6 = 1;
                                                                                        sensorId_2 = head(activePatternResult_7)[1];
                                                                                    }
                                                                                    else {
                                                                                        matchResult_6 = 2;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    matchResult_6 = 2;
                                                                                }
                                                                            }
                                                                            else {
                                                                                matchResult_6 = 2;
                                                                            }
                                                                        }
                                                                        else {
                                                                            matchResult_6 = 2;
                                                                        }
                                                                    }
                                                                    else {
                                                                        matchResult_6 = 2;
                                                                    }
                                                                }
                                                                else {
                                                                    matchResult_6 = 2;
                                                                }
                                                                break;
                                                            }
                                                            default:
                                                                matchResult_6 = 2;
                                                        }
                                                    }
                                                    else {
                                                        matchResult_6 = 2;
                                                    }
                                                    switch (matchResult_6) {
                                                        case 0:
                                                            return new Page(5, [undefined]);
                                                        case 1:
                                                            return new Page(6, [new SensorId(sensorId_2)]);
                                                        default: {
                                                            let matchResult_7, dateEnd, dateStart, sensorId_3;
                                                            if (!isEmpty(_arg)) {
                                                                switch (head(_arg)) {
                                                                    case "portwind-simple": {
                                                                        if (isEmpty(tail(_arg))) {
                                                                            matchResult_7 = 0;
                                                                        }
                                                                        else {
                                                                            matchResult_7 = 2;
                                                                        }
                                                                        break;
                                                                    }
                                                                    case "portwind-report": {
                                                                        if (!isEmpty(tail(_arg))) {
                                                                            const activePatternResult_8 = Route_$007CQuery$007C_$007C(head(tail(_arg)));
                                                                            if (activePatternResult_8 != null) {
                                                                                if (!isEmpty(activePatternResult_8)) {
                                                                                    if (head(activePatternResult_8)[0] === "sensor") {
                                                                                        if (!isEmpty(tail(activePatternResult_8))) {
                                                                                            if (head(tail(activePatternResult_8))[0] === "dateStart") {
                                                                                                if (!isEmpty(tail(tail(activePatternResult_8)))) {
                                                                                                    if (head(tail(tail(activePatternResult_8)))[0] === "dateEnd") {
                                                                                                        if (isEmpty(tail(tail(tail(activePatternResult_8))))) {
                                                                                                            if (isEmpty(tail(tail(_arg)))) {
                                                                                                                matchResult_7 = 1;
                                                                                                                dateEnd = head(tail(tail(activePatternResult_8)))[1];
                                                                                                                dateStart = head(tail(activePatternResult_8))[1];
                                                                                                                sensorId_3 = head(activePatternResult_8)[1];
                                                                                                            }
                                                                                                            else {
                                                                                                                matchResult_7 = 2;
                                                                                                            }
                                                                                                        }
                                                                                                        else {
                                                                                                            matchResult_7 = 2;
                                                                                                        }
                                                                                                    }
                                                                                                    else {
                                                                                                        matchResult_7 = 2;
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    matchResult_7 = 2;
                                                                                                }
                                                                                            }
                                                                                            else {
                                                                                                matchResult_7 = 2;
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            matchResult_7 = 2;
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        matchResult_7 = 2;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    matchResult_7 = 2;
                                                                                }
                                                                            }
                                                                            else {
                                                                                matchResult_7 = 2;
                                                                            }
                                                                        }
                                                                        else {
                                                                            matchResult_7 = 2;
                                                                        }
                                                                        break;
                                                                    }
                                                                    default:
                                                                        matchResult_7 = 2;
                                                                }
                                                            }
                                                            else {
                                                                matchResult_7 = 2;
                                                            }
                                                            switch (matchResult_7) {
                                                                case 0:
                                                                    return new Page(6, [undefined]);
                                                                case 1:
                                                                    return new Page(7, [new SensorId(sensorId_3), new DateTimeRange(PageModule_dateParse(dateStart), PageModule_dateParse(dateEnd))]);
                                                                default: {
                                                                    let matchResult_8, sensorId_4;
                                                                    if (!isEmpty(_arg)) {
                                                                        if (head(_arg) === "portwind-report") {
                                                                            if (!isEmpty(tail(_arg))) {
                                                                                const activePatternResult_9 = Route_$007CQuery$007C_$007C(head(tail(_arg)));
                                                                                if (activePatternResult_9 != null) {
                                                                                    if (!isEmpty(activePatternResult_9)) {
                                                                                        if (head(activePatternResult_9)[0] === "sensor") {
                                                                                            if (isEmpty(tail(activePatternResult_9))) {
                                                                                                if (isEmpty(tail(tail(_arg)))) {
                                                                                                    matchResult_8 = 0;
                                                                                                    sensorId_4 = head(activePatternResult_9)[1];
                                                                                                }
                                                                                                else {
                                                                                                    matchResult_8 = 1;
                                                                                                }
                                                                                            }
                                                                                            else {
                                                                                                matchResult_8 = 1;
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            matchResult_8 = 1;
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        matchResult_8 = 1;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    matchResult_8 = 1;
                                                                                }
                                                                            }
                                                                            else {
                                                                                matchResult_8 = 1;
                                                                            }
                                                                        }
                                                                        else {
                                                                            matchResult_8 = 1;
                                                                        }
                                                                    }
                                                                    else {
                                                                        matchResult_8 = 1;
                                                                    }
                                                                    switch (matchResult_8) {
                                                                        case 0:
                                                                            return new Page(7, [new SensorId(sensorId_4), new DateTimeRange(undefined, undefined)]);
                                                                        default: {
                                                                            let matchResult_9;
                                                                            if (!isEmpty(_arg)) {
                                                                                if (head(_arg) === "portwind-report") {
                                                                                    if (isEmpty(tail(_arg))) {
                                                                                        matchResult_9 = 0;
                                                                                    }
                                                                                    else {
                                                                                        matchResult_9 = 1;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    matchResult_9 = 1;
                                                                                }
                                                                            }
                                                                            else {
                                                                                matchResult_9 = 1;
                                                                            }
                                                                            switch (matchResult_9) {
                                                                                case 0:
                                                                                    return new Page(7, [undefined, new DateTimeRange(undefined, undefined)]);
                                                                                default:
                                                                                    return PageModule_defaultPage;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

export function PageModule_noQueryString(segments) {
    return [segments, empty()];
}

export function PageModule_toUrlSegments(_arg) {
    switch (_arg.tag) {
        case 11:
            return PageModule_noQueryString(singleton("login"));
        case 12:
            return PageModule_noQueryString(singleton("login-callback"));
        case 13:
            return PageModule_noQueryString(singleton("login-callback-silent"));
        case 0:
            return [singleton("models"), singleton(["param", WeatherTypeModule_ParameterModule_name(_arg.fields[0])])];
        case 2:
            if (_arg.fields[0].tag === 1) {
                return PageModule_noQueryString(ofArray(["sessions", _arg.fields[0].fields[0], "merged", _arg.fields[0].fields[1]]));
            }
            else {
                return PageModule_noQueryString(ofArray(["sessions", _arg.fields[0].fields[0]]));
            }
        case 3:
            return PageModule_noQueryString(ofArray(["sessions", _arg.fields[0], "report"]));
        case 1:
            return PageModule_noQueryString(singleton("vessels"));
        case 4:
            return PageModule_noQueryString(singleton("dashboard"));
        case 8:
            return PageModule_noQueryString(singleton("portwind-status"));
        case 9:
            return [singleton("portwind-outage-report"), ofArray(toArray(map((_arg_2) => ["sensor", _arg_2.fields[0]], _arg.fields[0])))];
        case 5:
            return [singleton("portwind"), ofArray(toArray(map((_arg_3) => ["sensor", _arg_3.fields[0]], _arg.fields[0])))];
        case 6:
            return [singleton("portwind-simple"), ofArray(toArray(map((_arg_4) => ["sensor", _arg_4.fields[0]], _arg.fields[0])))];
        case 7:
            return [singleton("portwind-report"), choose((x) => x, ofArray([map((_arg_5) => ["sensor", _arg_5.fields[0]], _arg.fields[0]), map((ds) => ["dateStart", toString(ds, PageModule_dateFormat)], _arg.fields[1].fields[0]), map((de) => ["dateEnd", toString(de, PageModule_dateFormat)], _arg.fields[1].fields[1])]))];
        default:
            return PageModule_noQueryString(singleton("logout"));
    }
}

function PageModule_firstUpper(s) {
    let c;
    return ((c = s[0], c.toLocaleUpperCase())) + s.slice(1, s.length);
}

/**
 * Builds the page title. When `sensorName` is provided it is shown instead of the sensor id
 * (used once the sensors are loaded and the friendly name becomes known).
 */
export function PageModule_titleWithSensorName(sensorName) {
    const addSensor = (s) => defaultArg(map((_arg) => concat(" - ", ...defaultArg(sensorName, PageModule_firstUpper(_arg.fields[0]))), s), "");
    return (_arg_1) => {
        switch (_arg_1.tag) {
            case 13:
            case 12:
            case 11:
                return "Login";
            case 0:
                return concat("Models - ", ...PageModule_firstUpper(WeatherTypeModule_ParameterModule_name(_arg_1.fields[0])));
            case 2:
                return "Session details";
            case 3:
                return "Session report";
            case 1:
                return "Vessels";
            case 4:
                return "Dashboard";
            case 8:
                return "PortWind - Status";
            case 9:
                return "PortWind - Outage Report" + addSensor(_arg_1.fields[0]);
            case 5:
                return "PortWind" + addSensor(_arg_1.fields[0]);
            case 6:
                return "PortWind Simple" + addSensor(_arg_1.fields[0]);
            case 7:
                return "PortWind Historic Data" + addSensor(_arg_1.fields[0]);
            default:
                return "Logout";
        }
    };
}

export const PageModule_title = PageModule_titleWithSensorName(undefined);

function Router_documentTitle(title) {
    return concat(title, ..." - Stena Weather Service UI");
}

/**
 * The browser tab title for a page (sensor shown by id, before the friendly name is known).
 */
export function Router_pageTitle(page) {
    return Router_documentTitle(PageModule_title(page));
}

/**
 * Sets the browser tab title, showing the sensor's friendly name instead of its id.
 */
export function Router_updateTitle(page, sensorName) {
    document.title = Router_documentTitle(PageModule_titleWithSensorName(sensorName)(page));
}

export function Router_goToUrl(e) {
    e.preventDefault();
    RouterModule_nav(singleton(e.currentTarget.attributes.href.value), 1, 2);
}

export function Router_navigatePage(p) {
    const tupledArg = PageModule_toUrlSegments(p);
    const queryString = tupledArg[1];
    defaultArgWith(map((tupledArg_1) => {
        RouterModule_nav(append(tupledArg_1[0], singleton(tupledArg_1[1] + RouterModule_encodeQueryString(queryString))), 1, 2);
    }, RouterModule_trySeparateLast(tupledArg[0])), () => {
        RouterModule_nav(singleton(RouterModule_encodeQueryString(queryString)), 1, 2);
    });
}

export function Router_setUrlToPage(p) {
    let url;
    const tupledArg = PageModule_toUrlSegments(p);
    const queryString = tupledArg[1];
    url = defaultArgWith(map((tupledArg_1) => RouterModule_encodeParts(append(tupledArg_1[0], singleton(tupledArg_1[1] + RouterModule_encodeQueryString(queryString))), 2), RouterModule_trySeparateLast(tupledArg[0])), () => RouterModule_encodeParts(singleton(RouterModule_encodeQueryString(queryString)), 2));
    history.pushState({
        page: url,
    }, "", url);
}

export function Cmd_navigatePage(p) {
    const tupledArg = PageModule_toUrlSegments(p);
    return Cmd_ofEffect((_arg_1) => {
        const queryString_1 = tupledArg[1];
        defaultArgWith(map((tupledArg_1) => {
            RouterModule_nav(append(tupledArg_1[0], singleton(tupledArg_1[1] + RouterModule_encodeQueryString(queryString_1))), 1, 2);
        }, RouterModule_trySeparateLast(tupledArg[0])), () => {
            RouterModule_nav(singleton(RouterModule_encodeQueryString(queryString_1)), 1, 2);
        });
    });
}

